import {requestAnimationFrame} from 'CommonUtils/raf.js';
import {EconimcCalendar} from '@cliotech-web/economic-calendar';


let lang = languageAttributes.spokenLanguageCode;

switch (lang) {
  case 'zh-hans':
    lang = 'zh_cn'; break;
  case 'tw':
    lang = 'zh_tw'; break;
  case 'hi':
    lang = 'hi'; break;
}

let ec_container = 'ec_wrapper',
    ec, 
    ecLoaded = false;
    
    function doScrolling() {
        if (!ecLoaded) {
            ecLoaded = true;
            ec = new EconimcCalendar(ec_container,lang,languageAttributes.broker);
            requestAnimationFrame(()=> document.getElementById(ec_container).classList.remove('loading'))
        }
    
    }

    window.outerWidth > 768 || window.isInViewport($('#ec_wrapper'))  ? doScrolling() : window.scrollingTasks.push(doScrolling);